// This file is generated.
export var version = '1.59.0';
//# sourceMappingURL=version.js.map